import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import PasswordGenerator from './pages/password-generator/PasswordGenerator';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h3 style={{ textAlign: 'left' }}>UtilyHub</h3>
          <nav>
            <Link className="App-link" to="/">Home</Link>
            <Link className="App-link" to="/password-generator">Password Generator</Link>
          </nav>
        </header>
        <Routes>
          <Route
            path="/"
            element={
              <div>
                <p style={{ width: '50%', textAlign: 'center', margin: 'auto' }}>
                  Welcome to UtilyHub! Explore our tools to enhance productivity.
                </p>
              </div>
            }
          />
          <Route path="/password-generator" element={<PasswordGenerator />} />
        </Routes>
        <footer>
          Made with love ❤ tiepnvbn@gmail.com
          <br />
          Something cool is coming soon!
        </footer>
      </div>
    </Router>
  );
}

export default App;
